<ag-grid-angular class="data-grid " [rowData]="dataset | async" [gridOptions]="gridOptions" [attr.aria-label]="widgetTitle"></ag-grid-angular>